import { z } from "zod";

// Ime osobe: provjera kao `custom` problem, da poruka ne dobije opšti naziv
// polja "name" ("Naziv") ispred sebe.
const personName = z
  .string()
  .trim()
  .max(120)
  .refine((v) => v.length >= 2, { message: "Ime i prezime je prekratko, potrebna su najmanje 2 znaka." });

export const TEAM_SIZE = ["1_10", "11_50", "51_200", "201_500", "500_plus"] as const;
export const TOPIC = ["general", "eap", "pricing", "demo", "other"] as const;

export const contactSchema = z.object({
  name: personName,
  email: z.string().trim().toLowerCase().email("Email nije ispravan.").max(200),
  company: z.string().trim().min(1).max(160),
  phone: z.string().trim().max(40).optional().or(z.literal("")),
  teamSize: z.enum(TEAM_SIZE, { message: "Veličina tima nije odabrana." }),
  topic: z.enum(TOPIC, { message: "Tema nije odabrana." }),
  message: z.string().trim().min(10, "Poruka je prekratka, potrebno je najmanje 10 znakova.").max(4000),
  // Honeypot — humans leave it empty. Accept any value so the handler can
  // silently "succeed" for bots instead of leaking a validation error.
  website: z.string().max(200).optional(),
});

export const FOOTER_AUDIENCE = ["client", "therapist"] as const;

export const footerContactSchema = z.object({
  name: personName,
  email: z.string().trim().toLowerCase().email("Email nije ispravan.").max(200),
  audience: z.enum(FOOTER_AUDIENCE),
  message: z.string().trim().min(10, "Poruka je prekratka, potrebno je najmanje 10 znakova.").max(2000),
  // Honeypot — humans leave it empty. Accept any value so the handler can
  // silently "succeed" for bots instead of leaking a validation error.
  website: z.string().max(200).optional(),
});
